$(document).ready(function () {
  const breakpoint = window.matchMedia( '(min-width: 750px)' );

  let blogLandingGrid;
  const blgBreakpointChecker = function() {
    if ( breakpoint.matches === true ) {
    if ( blogLandingGrid !== undefined ) blogLandingGrid.destroy( true, true );
      return;
    } else if ( breakpoint.matches === false ) {
      return blgEnableSwiper();
    }
  };


  const blgEnableSwiper = function() {
    const blogLandingGrid = new Swiper ('.swiper-blog-landing-grid', {
      loop: false,
      slidesPerView: 'auto',
      grabCursor: true,
      freeMode: true,
      spaceBetween: 0,
      direction: 'horizontal',
      mousewheel: {
        forceToAxis: true
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  };


  breakpoint.addListener(blgBreakpointChecker);

  blgBreakpointChecker();

});
